"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.renderMetaTags = function (data) {
    return data.map(({ tag, attributes, content }) => {
        let key = [tag];
        if (attributes && "property" in attributes) {
            key.push(attributes.property);
        }
        if (attributes && "name" in attributes) {
            key.push(attributes.name);
        }
        const Tag = tag;
        return (react_1.default.createElement(Tag, Object.assign({ key: key.join("-") }, attributes), content));
    });
};
const serializeAttributes = (attributes) => {
    if (!attributes) {
        return "";
    }
    return " " + Object.entries(attributes).map(([key, value]) => (`${key}="${value}"`)).join(" ");
};
exports.renderMetaTagsToString = function (data) {
    return data.map(({ tag, attributes, content }) => {
        if (content) {
            return `<${tag}${serializeAttributes(attributes)}>${content}</${tag}>`;
        }
        return `<${tag}${serializeAttributes(attributes)} />`;
    }).join("\n");
};
//# sourceMappingURL=index.js.map